<template>
    <div ref="editor" class="app-json-form-editor"></div>
</template>
 
<script>
import _ from 'lodash'
import EventBus from '../helpers/event-bus'
import JSONEditor from '../json-editor'
import Templater from '../json-editor/templater'
import Mustache from 'mustache'
Mustache.tags = ['<%=', '%>']

// reference to the original render function
const originalRender = Mustache.Writer.prototype.render;

const templater = new Templater()

// for testing purposes, to compare with lodash results enable unsafe-eval in SecureHeaders.php
// templater.testRender()

Mustache.Writer.prototype.render = function(template, view, partials, config)
{
    // cleanup any logic and things incompatible with mustache
    template = templater.cleanupTemplate(template, view)
    // Call the original render function
    const result = originalRender.call(this, template, view, partials, config);

    return result;
};

window.Mustache = Mustache

var Editor

export default {
    props: {
        content: [Object, Array],
        schema: [Object, Boolean],
        schemaKey: [String, Boolean],
        schemaRefs: {
            type: Object,
            default () {
                return { }
            }
        }
    },
    data () {
        return {
            initializing: false,
            ready: false,
            updating: false,
            value: _.cloneDeep(this.content)
        }
    },
    computed: {
        refs () {
            // this needs to be a fresh copy
            return _.cloneDeep(this.$store.getters['builder/schemaRefs']) || { }
        },
        customOptions () {
            return {
                datasets: this.$store.state.builder.datasets
            }
        },
        schemaObj () {
            if (this.schema) {
                return this.schema
            } else if (this.refs.definitions[this.schemaKey]) {
                return _.merge({ }, this.refs, this.refs.definitions[this.schemaKey])
            }
            return { }
        }
    },
    watch: {
        content (value) {
            // console.log('source content changed', value)
            this.value = _.cloneDeep(value)
        },
        schemaKey (value) {
            console.log('Schema changed, rebuild editor: ', value)
            this.buildEditor()
        }
    },
    methods: {
        reset () {
            //
        },
        getValue () {
            return Editor.getValue(true)
        },
        setValue (value) {
            Editor.setValue(value)
        },
        async onChange () {
            // console.log('Editor::onChange')

            try {
                await this.$nextTick()
                this.$emit('change', this.getValue())
            } catch (err) {
                console.error(err)
            }
        },
        buildEditor () {
            if (!this.value && !this.$refs.editor && this.$refs.editor.length == undefined)
            {
                console.log('no start value, skip')
                return;
            }
            this.ready = false
 
            if (Editor) {
                if (!Editor.initializing)
                    Editor.destroy()
                else {
                    return
                }
            }

            Editor = new JSONEditor(this.$refs.editor, {
                startval: this.value,
                schema: this.schemaObj,
                disable_theme_rules: true, // csp
                template: 'mustache',
                // refs: { ...this.refs },
                ...this.customOptions
            })

            Editor.on('ready', () => {
                // console.log('Editor::ready')
                // Editor.setValue(this.value)
                this.ready = true
                this.$emit('ready')
                // set change event listener (ignore first one)
                Editor.once('change', () => {
                    Editor.on('change', this.onChange)
                })
            })
        }
    },
    mounted () {
        if (this.ready || this.initializing)
            return
 
        this.initializing = true
 
        this.buildEditor()
    },
    created () {
        EventBus.$on('editor:setValue', this.setValue)
    }
}
</script>
